'use client'

import { Text, useBreakpointValue } from '@chakra-ui/react'
import React, { useState } from 'react'
import CommentDesktop from './comment.desktop'
import CommentMobile from './comment.mobile'
import { useQuery } from '@tanstack/react-query'
import reviewService from '@/app/[locale]/_service/review.service'
import { useTranslations } from 'next-intl'

const Comment = ({ id }: { id?: string }) => {
  const [isOpen, setOpen] = useState(false)

  const t = useTranslations()
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  const { data } = useQuery({
    queryKey: ['reviews', id],
    queryFn: () =>
      reviewService
        .getList({ related_subject: 'product', product_id: id })
        .then((res) => res?.data),
  })

  // if
  // } else {
  return (
    <>
      {Number(data?.count || 0) ? (
        <Text color='primary' fontSize='sm' onClick={() => setOpen(true)}>
          {t('reviews')} ({data?.count || 0})
        </Text>
      ) : (
        <Text opacity={0.2} fontSize='sm'>
          {t('no_reviews')}
        </Text>
      )}
      {isDesktop ? (
        <CommentDesktop
          open={isOpen}
          onClose={() => setOpen(false)}
          reviews={data?.reviews}
        />
      ) : (
        <CommentMobile
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          reviews={data?.reviews}
        />
      )}
    </>
  )
  // }
}

export default Comment
